<template>
  <div>
    <v-card
      class="pa-6"
      elevation="0"
    >
      <v-card-title class="text-title">
        2. Provide Your Integration Details
      </v-card-title>
      <div id="hubspotForm" />
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'HubSpotForm',
  props: {
    formId: { type: String, default: '' },
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '20222851',
          formId: this.formId,
          target: '#hubspotForm',
        });
      }
    });
  },
};
</script>

<style scoped lang="less">
  .form-panel {
    width: calc(50% - 6px);
  }
</style>
